
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { Tier } from "@/utils/tier";

export default Vue.extend({
	props: {
		value: Number,
		label: {
			type: String,
			default: "Editie"
		},
		fancy: Boolean
	},
	computed: {
		items():ISelectItem<Tier>[] {
			return [
				{
					text: "Free",
					value: Tier.Free
				},
				{
					text: "Starter",
					value: Tier.Starter
				},
				{
					text: "Professional",
					value: Tier.Pro
				},
				{
					text: "Prof PLUS",
					value: Tier.ProfessionalPlus
				},
				{
					text: "Enterprise",
					value: Tier.Enterprise
				}
			];
		}
	},
	methods: {
		onInput(tier:number) {
			this.$emit("input", tier);
		}
	}
});
